// File: src/api/Functions.js — normalized errors + consistent auth headers + BASE URLs
import axios from "axios";

// ===== Global axios defaults =====
const token = "SSp@LHp*$bp6kL";
axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
//axios.defaults.headers.common["x-access-token"] = token;
//axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";

const headers_post = {
  headers: {
    Authorization: `Bearer ${token}`, // match server middleware
  },
};

// ===== Base URLs =====
const BASE_URL_METAERO = process.env.REACT_APP_METAERO_API || "https://metaero.org:2053";
const BASE_URL_ALERTAIR = process.env.REACT_APP_ALERTAIR_API || "https://alertair.net:8443/api/alertair";

// ---- Error normalization helper ----
function normalizeAxiosError(err, fallbackCode) {
  const server = err?.response?.data || null;
  const status = err?.response?.status || 0;
  const code =
    (server && (server.code || server.error)) ||
    err?.code ||
    fallbackCode ||
    "unknown_error";
  const e = new Error(code);
  e.code = code;
  e.status = status;
  e.server = server;
  return e;
}

// ======================
// XBL Account helper(s)
// ======================
export async function getMSFSInfo(api_key) {
  const headers = {
    headers: {
      "X-Authorization": `${api_key}`,
      "X-Contract": `100`,
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    const response = await axios.get(`https://api.xbl.io/api/v2/account`, headers);
    return response;
  } catch (error) {
    console.error(error);
    throw normalizeAxiosError(error, "xbl_account_failed");
  }
}

// ======================
// AlertAir helpers
// ======================
export async function createPayment(data) {
  try {
    const response = await axios.post(`${BASE_URL_ALERTAIR}/createPayment`, data, headers_post);
    return response?.data;
  } catch (error) {
    console.error(error);
    throw normalizeAxiosError(error, "create_payment_failed");
  }
}

export async function addUser(data) {
  try {
    const response = await axios.post(`${BASE_URL_METAERO}/addUser`, data, headers_post);
    return response;
  } catch (error) {
    console.error(error);
    throw normalizeAxiosError(error, "add_user_failed");
  }
}

export async function addAlert(data) {
  try {
    const response = await axios.post(`${BASE_URL_ALERTAIR}/addAlert`, data, headers_post);
    return response;
  } catch (error) {
    console.error(error);
    throw normalizeAxiosError(error, "add_alert_failed");
  }
}

export async function deleteAlert(data) {
  const data1 = { alert_id: data };
  try {
    const response = await axios.post(`${BASE_URL_ALERTAIR}/deleteAlert`, data1, headers_post);
    return response;
  } catch (error) {
    console.error(error);
    throw normalizeAxiosError(error, "delete_alert_failed");
  }
}

export async function addAlertMobile(data) {
  try {
    const response = await axios.post(`${BASE_URL_ALERTAIR}/addAlertMobile`, data, headers_post);
    return response;
  } catch (error) {
    console.error(error);
    throw normalizeAxiosError(error, "add_alert_mobile_failed");
  }
}

export async function checkDuplicateAlert(data) {
  try {
    const response = await axios.post(`${BASE_URL_ALERTAIR}/checkDuplicateAlert`, data, headers_post);
    return response;
  } catch (error) {
    console.error(error);
    throw normalizeAxiosError(error, "check_duplicate_alert_failed");
  }
}

export async function findUser(data) {
  try {
    const response = await axios.post(`${BASE_URL_METAERO}/findUser`, data, headers_post);
    return response.data;
  } catch (error) {
    console.error(error);
    throw normalizeAxiosError(error, "find_user_failed");
  }
}

export async function delUser(data) {
  try {
    const response = await axios.post(`${BASE_URL_METAERO}/delUser`, data, headers_post);
    return response.data;
  } catch (error) {
    console.error(error);
    throw normalizeAxiosError(error, "delUserFailed");
  }
}


export async function findUserByID(data) {
  try {
    const response = await axios.post(`${BASE_URL_ALERTAIR}/findUserByID`, data, headers_post);
    return response.data;
  } catch (error) {
    console.error(error);
    throw normalizeAxiosError(error, "find_user_by_id_failed");
  }
}

export async function findPayment(data) {
  try {
    const response = await axios.post(`${BASE_URL_ALERTAIR}/findPayment`, data, headers_post);
    return response.data;
  } catch (error) {
    console.error(error);
    throw normalizeAxiosError(error, "find_payment_failed");
  }
}

export async function addCredits(data) {
  try {
    const response = await axios.post(`${BASE_URL_ALERTAIR}/addCredits`, data, headers_post);
    return response.data;
  } catch (error) {
    console.error(error);
    throw normalizeAxiosError(error, "add_credits_failed");
  }
}

export async function getUserAlerts(data) {
  try {
    const response = await axios.post(`${BASE_URL_ALERTAIR}/getUserAlerts`, data, headers_post);
    return response.data;
  } catch (error) {
    console.error(error);
    throw normalizeAxiosError(error, "get_user_alerts_failed");
  }
}

export async function getUserAlertsByReg(data) {
  try {
    const response = await axios.post(`${BASE_URL_ALERTAIR}/getUserAlertsByReg`, data, headers_post);
    return response.data;
  } catch (error) {
    console.error(error);
    throw normalizeAxiosError(error, "get_user_alerts_by_reg_failed");
  }
}

export async function getUserActivity(data) {
  try {
    const response = await axios.post(`${BASE_URL_ALERTAIR}/getUserActivity`, data, headers_post);
    return response.data;
  } catch (error) {
    console.error(error);
    throw normalizeAxiosError(error, "get_user_activity_failed");
  }
}

export async function applyPurchase(data) {
  try {
    const response = await axios.post(`${BASE_URL_ALERTAIR}/applyPurchase`, data, headers_post);
    return response.data;
  } catch (error) {
    console.error(error);
    throw normalizeAxiosError(error, "apply_purchase_failed");
  }
}

// ======================
// Metaero endpoints
// ======================
export async function get_fly_voucher({ api_key, walletAddress }) {
  try {
    const res = await axios.post(`${BASE_URL_METAERO}/fly_voucher`, { api_key, walletAddress }, headers_post);
    return res.data; // { claimParams, signerAddress, digest, debug? } or { error: ... }
  } catch (err) {
    throw normalizeAxiosError(err, "fly_voucher_failed");
  }
}

export async function get_app(code) {
  const data = { code, app_key: "73ad1282-537a-49f8-ba1e-85b186fe94b6" };
  try {
    const result = await axios.post(`${BASE_URL_METAERO}/get_api`, data, headers_post);
    return result.data;
  } catch (error) {
    console.error(error);
    throw normalizeAxiosError(error, "get_app_failed");
  }
}
// near the top of src/api/Functions.js
axios.defaults.timeout = 12000; // 12s hard stop

// Generic POST-with-retry helper (exponential backoff)
async function postWithRetry(url, data, config, { retries = 2, baseDelay = 400 } = {}) {
  let lastErr;
  for (let i = 0; i <= retries; i++) {
    try {
      return await axios.post(url, data, config);
    } catch (err) {
      lastErr = err;
      const status = err?.response?.status;
      const isNetwork = err?.code === "ERR_NETWORK" || !err?.response;
      const retriable = isNetwork || (status >= 500 && status !== 501);
      if (i < retries && retriable) {
        const delay = baseDelay * Math.pow(2, i) + Math.floor(Math.random() * 150);
        await new Promise(r => setTimeout(r, delay));
        continue;
      }
      break;
    }
  }
  throw lastErr;
}

export async function get_account(app_key) {
  try {
    const res = await postWithRetry(`${BASE_URL_METAERO}/get_account`, { app_key }, headers_post);
    return res.data;
  } catch (error) {
    const code = error?.response?.data?.error || error?.response?.data?.code;
    if (code === "msfs_title_not_found") return { error: "msfs_title_not_found" };
    if (error?.code === "ERR_NETWORK" || !error?.response) return { error: "network_error" };
    throw normalizeAxiosError(error, "get_account_failed");
  }
}
export async function get_fly_preview({ api_key, walletAddress }) {
  try {
    const r = await axios.post(`${BASE_URL_METAERO}/fly_preview`, { api_key, walletAddress }, headers_post);
    return r.data;
  } catch (err) {
    throw normalizeAxiosError(err, "fly_preview_failed");
  }
}

export async function mint_nft(data) {
  try {
    const res = await axios.post(`${BASE_URL_METAERO}/mint_nft`, data, headers_post);
    return res.data; // success path includes: walletAddress, xboxId, tokenURI, nonce, signature, signerAddress
  } catch (err) {
    throw normalizeAxiosError(err, "mint_nft_failed");
  }
}
